/**
 * Modifier-key → order side for the SuperDOM (book) order entry.
 *
 * Mirrors the chart's convention (Shift = buy, Ctrl/Cmd = sell). Because the DoM
 * has explicit buy/sell columns, the modifier must ALSO match the clicked column's
 * side — so cross combos (Shift on the sell column, Ctrl on the buy column) place
 * nothing. Holding both Shift and Ctrl is ambiguous and also resolves to nothing.
 *
 * Kept local to the book on purpose (the chart's own handlers are left untouched).
 *
 * @param {{shiftKey?:boolean, ctrlKey?:boolean, metaKey?:boolean}} event
 * @param {"buy"|"sell"} side  the clicked column's side
 * @returns {boolean} whether an order on `side` is armed by the current modifiers
 */
export const orderModifierForSide = (event, side) => {
  if (!event) return false;
  const shift = !!event.shiftKey;
  const ctrlOrCmd = !!event.ctrlKey || !!event.metaKey;
  if (side === "buy") return shift && !ctrlOrCmd;
  if (side === "sell") return ctrlOrCmd && !shift;
  return false;
};
